import { jsxs as i, jsx as C } from "react/jsx-runtime";
import { useId as l } from "react";
const s = ({ size: t, className: e }) => {
  const r = l();
  return /* @__PURE__ */ i(
    "svg",
    {
      className: e,
      fill: "none",
      height: t,
      viewBox: "0 0 60 60",
      width: t,
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ i("mask", { id: r, children: [
          /* @__PURE__ */ C(
            "path",
            {
              d: "M30 0C35.9334 0 41.7336 1.75947 46.6671 5.05591C51.6006 8.35235 55.4458 13.0377 57.7164 18.5195C59.987 24.0013 60.5811 30.0333 59.4236 35.8527C58.266 41.6721 55.4088 47.0176 51.2132 51.2132C47.0176 55.4088 41.6721 58.266 35.8527 59.4236C30.0333 60.5811 24.0013 59.987 18.5195 57.7164C13.0377 55.4458 8.35235 51.6006 5.05591 46.6671C1.75947 41.7336 0 35.9334 0 30C0 22.0435 3.16071 14.4129 8.7868 8.7868C14.4129 3.16071 22.0435 0 30 0Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M33.043 30.353L41.153 22.241C41.3295 22.0645 41.4695 21.855 41.565 21.6244C41.6605 21.3938 41.7097 21.1466 41.7097 20.897C41.7097 20.6474 41.6605 20.4002 41.565 20.1696C41.4695 19.939 41.3295 19.7295 41.153 19.553C40.9765 19.3765 40.767 19.2365 40.5364 19.141C40.3058 19.0455 40.0586 18.9963 39.809 18.9963C39.5594 18.9963 39.3122 19.0455 39.0816 19.141C38.851 19.2365 38.6415 19.3765 38.465 19.553L30.355 27.665L22.245 19.553C22.0685 19.3765 21.859 19.2365 21.6284 19.141C21.3978 19.0455 21.1506 18.9963 20.901 18.9963C20.6514 18.9963 20.4042 19.0455 20.1736 19.141C19.943 19.2365 19.7335 19.3765 19.557 19.553C19.3805 19.7295 19.2405 19.939 19.145 20.1696C19.0495 20.4002 19.0003 20.6474 19.0003 20.897C19.0003 21.1466 19.0495 21.3938 19.145 21.6244C19.2405 21.855 19.3805 22.0645 19.557 22.241L27.667 30.353L19.557 38.465C19.2006 38.8214 19.0003 39.3049 19.0003 39.809C19.0003 40.3131 19.2006 40.7965 19.557 41.153C19.9135 41.5094 20.3969 41.7097 20.901 41.7097C21.4051 41.7097 21.8886 41.5094 22.245 41.153L30.355 33.041L38.465 41.153C38.8215 41.5094 39.3049 41.7097 39.809 41.7097C40.3131 41.7097 40.7966 41.5094 41.153 41.153C41.5095 40.7965 41.7097 40.3131 41.7097 39.809C41.7097 39.3049 41.5095 38.8214 41.153 38.465L33.043 30.353Z",
              fill: "black"
            }
          )
        ] }) }),
        /* @__PURE__ */ C(
          "rect",
          {
            fill: "currentColor",
            height: "100%",
            mask: `url(#${r})`,
            width: "100%"
          }
        )
      ]
    }
  );
};
export {
  s as CrossCircleContained
};
